import React from "react";

export default function EmphasisBanner({ children }) {
  return (
    <div className="rounded-xl bg-gradient-to-br dark:from-yellow-500/50 from-yellow-50 dark:to-orange-500/50 to-orange-100 p-2 flex flex-col md:flex-row items-center md:space-x-4 space-y-4 md:space-y-0 divide-yellow-100 dark:divide-yellow-800 md:divide-y-0 border-2 border-orange-100 dark:border-yellow-600/50">
      {children}
    </div>
  );
}
